export default __webpack_public_path__ + "static/media/rosia_2.bcd204c8.jpeg";